import EN from './EN';

export default {
  quickActions: 'クイックアクション',
  ...EN,
  servers: {
    name: 'サーバー',
    auto: '自動',
    vietnam: 'ベトナム',
    singapore: 'シンガポール',
    main: 'メイン',
    reserve: '予備'
  },
  recommend: 'お勧めします',
  quantityInvalid: '無効な数量',
  returnToHome: 'ホーム画面に戻る',
  forever: '永遠に',
  barcodeTable: '商品バーコードテーブル',
  price: '価格',
  autoGen: '自動生成',
  expired: '期限切れ',
  check: 'チェック',
  signature: '署名',
  renew: '更新',
  updatedAt: '更新時刻',
  saveDraft: 'ドラフトを保存',
  buy: '購入',
  birthday: '誕生日',
  barcodeNotFound: 'このバーコードは見つかりませんでした!',
  saved: '保存されました',
  reality: '現実',
  difference: '違い',
  hide: '隠す',
  editComponent: '外観をカスタマイズする',
  amount: '量',
  search: '検索',
  simple: 'シンプル',
  more: 'もっと',
  share: '共有',
  saveImage: '画像を保存',
  next: '続行',
  inventoryDelivery: '在庫納品',
  type: 'タイプ',
  transactionHistory: 'トランザクション履歴',
  blanceAndDebt: '残高/借金',
  limitWarning: '度重なる返金のため、あなたのアカウントは制限されています。」 3 回を超えると、アカウントは永久にロックされ、データを回復できなくなります。 ありがとう！',
  upgradePro: 'アップグレード',
  iapSupport: '',
  emptyData: 'まだデータがありません',
  seemore: 'もっと見る',
  version: 'バージョン',
  financialIn30days: '過去 30 日間の金融',
  financialInMonth: '今月の財務',
  orFastLoginWith: 'または高速ログイン',
  fontSize: 'フォントサイズ',
  changeFontSizeWarning: 'フォントサイズが変更されました。 アプリを安定して動作させるには、アプリケーションを終了して再起動する必要があります',
  fontSizeList: ['小', '小', '中', '大', '非常に大きい', '非常に非常に大きい'],
  contact: '連絡先',
  cause: '理由',
  default: 'デフォルト',
  manager: '管理',
  paymentMethod: '支払い方法',
  paymentMethodList: ['現金', '銀行振込', 'デビット'],
  printerVideoDemo: '연결 안내 동영상',
  supportWarning: 'サポートが必要な場合は、開発チームの Facebook チャネルにお問い合わせください。 ご協力ありがとうございます！',
  offlineWarning:
    'オフラインで使用しています。 データ損失を回避し、他の多くの機能を使用できるようにするため、およびデスクトップ バージョンを使用できるようにするために、オンラインで使用するアカウントを登録する必要があります.',
  updating: '更新中',
  remain: '残り',
  choiceProductTypeWarning: '商品カテゴリを選択してください',
  editProduct: '商品の編集',
  onlyOnlineSupport: 'この機能はオンラインのみをサポートします。 この機能を使用するには、アカウントにログインしてください!',
  createBy: '작성자',
  userName: '사용자 ',
  fullName: '이름과',
  webVersion: '웹',
  syncingProgress: '동기화가 진행 . 1~15분 . ',
  bulkDelete: '대량 ',
  sync: '동기화',
  offline: '오프라인',
  offlineNotSupport: '오프라인',
  oldPrint: '請求書印刷（シンプル）',
  warning: '警告',
  back: '戻る',
  yes: 'はい',
  no: 'いいえ',
  refresh: '更新',
  tryAgain: '再試行',
  home: 'ホーム',
  language: '言語',
  theme: '外観',
  quantity: '金額',
  dark: '暗い',
  light: 'ライト',
  total: '合計',
  totalMoney: '合計金額',
  paid: '支払い済み',
  totalDebit: '未払いの合計',
  totalOldDebit: '古い債務',
  totalReminder: '残りの合計',
  totalOldReminder: '古いバランス',
  debit: 'お世話になっています',
  remainder: '残り',
  status: 'ステータス',
  create: '新規追加',
  add: '新規追加',
  save: '保存',
  print: '印刷する',
  export: '請求書のエクスポート',
  copy: 'コピー',
  edit: '編集',
  delete: '削除',
  update: '更新',
  updateStatus: 'ステータスの更新',
  day: '日',
  from: 'から',
  to: 'まで',
  fromDate: '開始日',
  toDate: '終了日',
  choiceImage: '画像を選択',
  exist: 'すでに存在する',
  invalidParams: '十分なデータを入力してください',
  success: '成功',
  fail: '失敗',
  all: 'すべて',
  complete: '完了',
  pending: '保留中',
  canceled: 'キャンセル済み',
  cancel: 'キャンセル',
  ok: '同意する',
  or: 'または',
  choice: '選択',
  confirm: '確認',
  confirmExitApp: 'アプリを終了しますか？',
  time: '時間',
  notFound: 'データが見つかりません。もう一度やり直してください！',
  createdAt: '作成日',
  none: 'なし',
  detail: '詳細',
  filter: 'フィルタ',
  filterByTim: '時間でフィルタリング',
  note: '注',
  trial: '試してみてください',
  option: 'オプション',
  notify: '通知',
  understand: '明らかに',
  exportToExcel: 'Excelにエクスポート',
  sorryText: '',
  multiHidden: 'まとめて隠す',
  multiActive: 'バッチ トリガー',
  hiddenList: '隠しリスト',
  showList: 'アクティベーション リスト',
  importDataFromExcel: 'Excelからインポート',
  describe: '製品の説明',
  addImage: '画像を追加',
  limitUpload: '一度に投稿できる写真は最大 5 枚までです',
  limitFeature: {
    intro: '無料で体験できます。 本当に必要なときに支払います。',
    free: '無料版',
    pro: 'プレミアム (有料) バージョン',
    title: 'この機能を使用するには、プレミアム バージョンを購入する必要があります',
    package: 'プレミアムパッケージ',
    packageOther: 'その他のサービス パッケージ',
    features: [
      '広告なし',
      'グッズ作成無制限（無料版はグッズ100個まで）',
      '無制限の注文',
      '無制限の請求書の印刷または発行',
      '商品バーコード印刷機能（Web版）',
      'お客様向けポイント蓄積機能',
      '注文コピー機能',
      '販売者支払可能追加料金機能',
      '返品機能',
      '古い商品機能を非表示',
      '商品分類機能（例：ジーンズ商品のサイズ分類はM、L、XL）',
      'データを Excel ファイルにインポートおよびエクスポートする機能',
      '領収書と支払いを追加する機能',
      '顧客に古い債務伝票を追加する機能',
      '納品書作成機能',
      '注文に対して直接支払いを行うための QR コードを作成する機能',
      '下書きメニュー機能、ネットワーク接続がない場合に下書きメニューを作成',
      'Web版（デスクトップ）使い放題'
    ],
    freeFeatures: [
      '広告を表示しますか',
      '商品は100個まで',
      '古い商品を隠す機能を制限する',
      '販売者追加料金機能を制限する',
      '返品制限機能',
      '限定されたバーコード印刷機能',
      'お客様限定ポイント蓄積機能',
      '限定された商品分類機能',
      '請求書の印刷またはエクスポートを制限する',
      'Excel へのエクスポートを制限する',
      '領収書と支払いの追加機能を制限する',
      '債務証書を追加する機能を制限する',
      'Excel ファイルから商品と顧客をインポートする機能を制限する',
      '納品書の作成機能を制限する',
      'ドラフトメニュー機能を制限する',
      '決済限定QRコード作成機能',
      'Web版3ヶ月無料'
    ]
  },
  syncDetail: {
    text1: 'デバイスからアカウントにデータを同期します。 このプロセスは1回だけ実行する必要があります。 ',
    text2: '各アカウントは1回だけ正常に同期できます',
    text3: 'この関数はまだテスト中です。 エラーが発生した場合は,できるだけ早く開発者にサポートを依頼してください。 ',
    start: '同期の開始',
    feedback: '開発者へのフィードバック',
    sendErrorData: 'エラーデータを送信する',
    sure: 'このアカウントとデータを同期してもよろしいですか？',
    syncedError: 'このアカウントはクロックされており,',
    syncedAlert: 'あなたのこのアカウントはオフラインのデータではありません。 今すぐ同期しますか？ '
  },
  statitical: {
    ...EN.statitical,
    chart: 'チャート',
    title: '統計',
    sale: '販売',
    expense: '費用',
    debtBook: 'デビットブック',
    returnOrderTitle: '返品注文統計',
    revenue: '利益',
    saleToday: '今日',
    sale7Days: '7日',
    sale30Days: '30日',
    chart7Days: '最近の7日間のグラフ',
    saleTitle: '販売統計',
    revenueTitle: '利益統計',
    orderTitle: '注文統計',
    order: '注文',
    stock: '在庫統計',
    quantityOfInventoryByCategory: 'カテゴリ別の在庫',
    quantityOfInventory: 'ユニットあたりの在庫量',
    inventoryCapital: '在庫資本',
    inventoryCapitalDetail: '（現在の入力価格による）',
    quantityOfInventoryProduct: '最も在庫のある製品',
    saleOfStaff: '従業員の売上'
  },
  menu: {
    ...EN.menu,
    category: 'カテゴリ',
    statitical: '統計',
    orderReturn: '返品',
    reportLogBug: 'エラーログを送信',
    version: 'バージョン',
    other: 'その他',
    setting: '設定',
    shortcut: 'ショートカット',
    account: 'アカウント',
    feedback: 'フィードバックと提案',
    share: 'このアプリを友達に送信',
    reportBug: 'エラーレポートデータの送信',
    policy: '使用ポリシー',
    term: '利用規約',
    editProfile: '編集情報',
    support: 'サポート'
  },
  settingForStaff: {
    ...EN.settingForStaff,
    branchHint: 'このエントリはカフェ & レストラン ビジネスのみを対象としています',
    title: 'ストア設定',
    staff: 'スタッフ',
    staffApp: '従業員用アプリ',
    emailExist: 'メールは既に存在します',
    branch: '支店と基本',
    cafe: 'カフェ＆レストラン',
    passForStaff: '従業員パスワード',
    passForStaffDetail: '営業アプリケーションの従業員ログインのための特別なパスワード。マスターパスワードと同じにしないでください。',
    mainBranch: 'メイン',
    addBranch: 'ベースを追加',
    editBranch: 'ベースの修正',
    addStaff: '従業員の追加',
    editStaff: '従業員の編集',
    table: 'テーブル',
    branchName: 'デフォルト名',
    branchTable: 'テーブル数',
    staffs: '従業員リスト',
    staffsDetail: '各店舗では、最初の従業員には 1 か月間無料の特典が与えられます。',
    upgradeStaff: '更新',
    appForStaffIntro:
      '従業員リストアプリ、従業員はこのアプリを使用して注文を作成できます。使用するには従業員アカウントを作成する必要があります。データがデフォルトアカウントに同期されます。',
    shopType: '業界',
    grocery: '食料品、スーパーマーケット',
    appForStaff: ['aSeller for Staff'],
    appForStaffDetail: ['レストラン、カフェ、お茶、食料品、小売店に適しています...'],
    shopTypeDetail: '適切な業種を選択して、従業員向けの販売アプリケーションで適切なインターフェイスを使用してください',
    showCustomer: '顧客を従業員に表示',
    showCustomerDetail: '従業員アプリに顧客リストを表示',
    customerShowMode: ['すべて表示', '従業員ゲストのみ', '非表示'],
    upgradeStaffContact: '',
    service: 'サービス',
    serviceDetail: 'ショップ、カフェ、ミルクティー、レストラン...',
    retail: '小売',
    retailDetail: '食料品店、スーパーマーケット...',
    showStatistial: '毎週の売上を表示',
    showStatistialDetail: '従業員に過去 7 日間の売上の表示を許可する'
  },
  prefix: { title: 'プレフィックス', detail: '注文コード、製品コードの前に表示される文字列...例: 注文コード: HD123' },
  account: {
    ...EN.account,
    systemSmartSubtitle: 'スマートな販売管理システム',
    switch: 'アカウント切り替え',
    switchConfirm: 'アカウント %s に切り替えてもよろしいですか？',
    switchDeleteConfirm: 'アカウント %s のログインセッションを削除してもよろしいですか？',
    requiredInfo: '必要な情報をすべて入力してください',
    enterCodeRequired: '確認コードを入力してください',
    enterPasswordRequired: '両方のパスワードを入力してください',
    passwordNotMatch: '2つのパスワードが一致しません',
    loginSubtitle: 'おかえりなさい！',
    registerSubtitle: '今すぐ登録して始めましょう！',
    noAccountYet: 'アカウントをお持ちではありませんか？',
    alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
    forgotPasswordStepEmail: 'パスワード再設定を開始するにはメールアドレスを入力してください。',
    forgotPasswordStepCode: 'メールに送信された6桁の確認コードを入力してください。',
    forgotPasswordStepPassword: 'アカウントを保護するために強力なパスワードを使用してください。',
    backToLogin: 'ログインに戻る',
    loginWithoutEmail: 'メールなしでログイン',
    loginWithoutEmailError: 'エラー: デバイスコードを生成できません。サポートにお問い合わせください！',
    offlineDeprecated:
      '2025年3月13日以降、このアプリはオフライン機能をサポートしなくなりました。\n無料でオフラインを使用するには、aSeller Offlineアプリ（オレンジ色のアイコン）をダウンロードしてください。\nありがとうございます！',
    errorCode: '無効な確認コード',
    sendCodeSuccess: 'コードを記載したメールを送信しました。 メールで確認コードを確認してください',
    codeExpired: '検証コードの有効期限が切れています。',
    forgotPassword: 'パスワードを忘れた',
    enterEmail: 'メールアドレスを入力してください',
    enterCode: '確認コードを入力してください',
    sendCode: '確認コードを送信します',
    submitCode: '確認',
    changePassword: 'パスワードの変更',
    newPassword: '新しいパスワード',
    renewPassword: '新しいパスワードをリセット',
    password: 'パスワード',
    repassword: 'パスワードを再入力してください',
    register: '登録',
    inputSoShort: 'ユーザー名またはパスワードが短すぎます',
    repassWrong: '再入力されたパスワードが正しくありません',
    emailExist: 'メールは既に存在します',
    logout: 'ログアウト',
    login: 'ログイン',
    offlineMode: 'オフラインで使用',
    offlineModeWarning: 'オフラインで使用すると,データはデバイスに保存されます。 データを失うことなく,別のデバイスに切り替える前にサインインする必要があります」',
    logoutConfirmMessage: 'このアカウントからサインアウトしてもよろしいですか？',
    notFoundEmail: 'このメールでアカウントが見つかりません',
    errorPassword: 'パスワードが正しくありません',
    emailInvalid: 'メールの形式が正しくありません',
    titleRequest: 'このメールに関連付けられたパスワードを変更するリクエストを受け取りました。',
    enterCodeEmail: 'メールに送信された確認コードを入力してください'
  },
  setting: {
    ...EN.setting,
    vote: '評価を評価して！！',
    timeFormat: '日付形式',
    about: 'About',
    title: '一般設定',
    help: 'ヘルプが必要ですか？',
    currency: '通貨',
    oddNumber: '奇数の単位を使用',
    oddNumberEx: '例:1000.15VND、0.5KG ...',
    sync: 'データ',
    login: 'ログイン',
    logout: 'ログアウト',
    notSignin: 'サインインされていません',
    syncIntro: 'Googleアカウントにログインしてバックアップを取り、データを安全に保ち、他のデバイスに転送できるようにします',
    syncNow: '今すぐバックアップ',
    lastSync: '最後のバックアップ',
    restore: 'データを復元する',
    requireLogin: 'この機能を実行するには、Googleアカウントでサインインする必要があります',
    syncNotFound: 'バックアップが見つかりません',
    confirmSync: 'サーバー上のデータは上書きされます。データを同期してもよろしいですか？',
    confirmRestore: 'データを復元してもよろしいですか、既存のデータは上書きされますか？',
    loginExpired: 'ログインセッションが期限切れになりました。もう一度ログインしてください！',
    autoBackup: 'データを自動的にバックアップします',
    googleAccountConnect: 'Googleアカウント',
    on: 'オン',
    off: 'オフ',
    googleLogoutConfirm: 'このGoogleアカウントを終了してもよろしいですか？',
    print: 'プリンタ接続',
    printDetail: '接続して製品の請求書を印刷するBluetoothプリンターを選択します',
    connectPrinter: 'プリンター',
    invoice: '請求書',
    invoiceHello: 'ありがとうございます',
    surchargeText: '請求書の単語追加料金を変更',
    invoiceSignature: '署名を表示',
    invoiceDebt: '未払い残高を表示',
    invoiceDebtInfo: '注文詳細、請求書、請求書に未払い残高を表示',
    debt: '負債',
    invoiceDebtDetail: '詳細借方',
    invoiceDebtDetailDetail: '差分メモにアイテムの詳細を表示',
    invoiceDiscount: '％offを表示',
    invoiceHelloDetail: '請求書の下にある顧客への礼状を編集します',
    warningOutStock: '在庫切れの警告',
    warningOutStockDetail: '在庫がなくなると、注文を追加できなくなります',
    warningOutStockMessage: '商品の在庫がありません。 さらに入力するか、設定でこの警告を無効にしてください',
    showRevenue: '利益を表示',
    orderStatus: '注文ステータスの表示',
    orderStatusDetail: '「保留」または「完了」状態を表示します。 有効にすると、注文の領収書を生成することはできません。',
    showHomeRevenue: '利益を表示',
    showHomeChart: 'チャートを表示',
    showHomeFinancial: '財政を表示',
    showHomeStatistial: '統計を表示',
    averageBuyPrice: '平均輸入価格',
    averageBuyPriceDetail: '利益をより正確に計算するために、輸入価格は各輸入後に自動的に平均化されます。\n式 = (現在の在庫合計 + 新しい在庫量)/(合計数量)',
    showSurchargeShopPay: '販売者が支払った追加料金を表示',
    showSurchargeShopPayDetail: '選択しない場合、販売者が支払った追加料金は請求書または請求書に表示されません'
  },
  customer: {
    ...EN.customer,
    id: 'ゲストID',
    prefix: 'カスタマーコードプレフィックス',
    title: '顧客',
    create: '顧客の追加',
    name: '顧客名',
    address: 'アドレス',
    phone: '電話番号',
    email: 'Eメール',
    add: '新しい顧客を追加',
    choice: '顧客を選択',
    invalidPhoneOrAddress: '電話番号または住所を入力してください',
    phoneExist: 'この電話番号は既に存在します',
    search: '名前または電話番号でフィルタリング',
    free: '小売顧客',
    orderStatistics: '注文統計',
    exportDebt: 'デビットノートを作成する',
    addDebt: '約束手形を追加',
    yearOld: '세歳',
    countBirthDay: '残り %s 日',
    taxCode: '納税コード',
    citizenId: '身分証明書番号',
    taxCodeHint: '納税番号で組織を検索できます',
    createScreen: {
      taxCodeNotFound: '納税番号情報が見つかりません',
      avatarLabel: 'プロフィール画像',
      contactHint: '連絡先から情報をすばやく入力、またはプロフィール画像を追加できます',
      basicInfoTitle: '基本情報'
    }
  },
  order: {
    lastPrice: '最終価格',
    lastPriceAuto: '最終販売価格を自動適用',
    lastPriceAutoDetail: '顧客の注文に小売価格ではなくその顧客への最終販売価格を自動適用します',
    ...EN.order,
    editDeadline: '注文編集期限',
    editDeadlineDetail: '注文作成日からこの日数以内で注文を編集できます。',
    editDeadlineExpired: '注文の編集期限を過ぎています。「設定」->「注文設定」で注文の編集可能期間を変更してください。',
    id: '単一コード',
    prefix: '注文コードプレフィックス',
    title: '販売注文',
    create: '注文の追加',
    edit: '注文の編集',
    realPrice: '実際の価格',
    detail: '注文の詳細',
    exportInvoice: '支払い請求書',
    add: '製品を追加',
    infoShop: 'ショップ情報',
    invalidCustomer: '顧客情報を選択してください',
    invalidProduct: '注文にアイテムがありません',
    confirmDelete: 'この %s は必ず削除してください？',
    search: '注文コード、顧客名、または電話番号でフィルタリング',
    discount: '割引',
    discount1: '割引',
    inStockNotEnough: '在庫のある商品の数が足りません。より多くの商品を入力するか、在庫数を更新してください。 ',
    createFailed: '注文の作成に失敗しました。もう一度やり直すか、開発者にフィードバックしてください。',
    surcharge: '追加料金',
    surchargeDetail: '（船、税金...）',
    barcodeNotFound: 'このバーコードはまだ存在していません。注文に追加する前に商品を入力してください ',
    price: '価格',
    customPrice: 'カスタム価格',
    customPrice1: '％減少',
    orderMoneyUpdated: '販売価格の変更により、注文の値が更新されました',
    totalProductMoney: '商品の合計金額',
    totalMustPaidMoney: '支払い総額',
    totalPaidMoney: '顧客が支払う',
    totalDebtMoney: '総支払額',
    paid: '支払済み',
    totalLiabilities: '総負債',
    totalMustPaidMoneyForCustomer: '合計はゲストに返される必要があります',
    totalPaidMoneyForCustomer: 'ゲストを返す',
    pointDiscount: '蓄積ポイントを減らす',
    money: '注文総額',
    statusOffRequire: '注文ステータスをオフにする',
    statusOffRequireDetail:
      '注文の領収書を作成するため。 注文の未払い残高に関して混乱が生じる可能性があるため、注文ステータスをオフにする必要があります。 この機能を使用するには注文ステータスを無効にしてもよろしいですか?',
    surchargeType2: '販売者が支払う',
    surchargeType1: '購入者が支払う',
    surchargeTypeHint:
      '- 購入者の支払い: 注文金額に含まれますが、収益には含まれますが、利益には含まれません。\n- 販売者の支払い: 注文金額には含まれません。ストアの経費を含めるために対応する支払い伝票が作成されます。',
    emptyProduct: '商品を追加してください',
    draftOrderWarning: '注意: これは暫定的な請求書であり、まだデータベースに保存されていません。'
  },
  product: {
    ...EN.product,
    multiStopSale: '一括販売停止',
    multiSale: '商品を一括販売',
    stopSale: '販売停止',
    sale: '販売',
    stopSaleList: '販売停止リスト',
    saleList: '販売中リスト',
    id: '商品コード',
    prefix: '商品コードプレフィックス',
    title: '商品',
    create: '商品を追加',
    add: '商品を追加',
    choice: '商品を選択',
    price: '製品価格',
    name: '商品名',
    priceType: '価格を選択',
    buyPrice: '価格を入力',
    sellPrice: '小売価格',
    sellPrice1: 'プロモーション価格',
    sellPrice2: '卸売価格',
    recent: '最近追加された製品',
    initStockDetail: '新製品作成時の初期在庫数量',
    search: 'コード、商品名でフィルタリング',
    sold: '販売済み',
    inStock: '残り',
    outOfStock: '在庫切れ',
    barcode: 'コード',
    exist: '商品はすでに存在します。名前またはバーコードを再確認してください',
    canNotDelete: 'このアイテムは既に注文されているため、削除できません。最初に注文を削除してください。',
    errorPrice: '無効な販売価格または入力価格',
    changeSellPriceWarning: '注:価格の変更は既存の注文に影響します',
    changeSellPriceWarningDetail: '価格の変更は既存の注文に影響します。このアイテムを含む注文を更新する必要があります。これを実行してもよろしいですか？',
    deleteNumProduct: '％s製品を削除',
    deleteNumProductConfirm: 'この製品の％sを削除してもよろしいですか？',
    hiddenNumProduct: '%s 製品を販売停止',
    activeNumProduct: '%s 製品を販売',
    hiddenNumProductConfirm: 'この製品の %s を販売停止にしてもよろしいですか?',
    activeNumProductConfirm: 'この製品 %s を販売してもよろしいですか?',
    canNotDeleteProduct: 'すでに注文されているため、%sつの商品を削除することはできません',
    barcodeExist: 'このバーコードは別の製品に既に存在します.',
    syncAmount: '在庫をインポート注文と同期',
    syncAmountConfirm: 'この商品の在庫は %s です。 もう一度更新しますか?',
    type: 'カテゴリー',
    type1: 'カテゴリー(サイズ、色...)',
    typeHint: 'クラス名',
    sku: 'スク',
    skuExist: 'この SKU はすでに存在します。 別の値を入力してください。',
    limitUploadImage: '無料版では、製品ごとに 1 つの画像のみがサポートされます。 さらに画像を追加するにはアップグレードしてください。'
  },
  staffUpgrade: {
    upgradeForStaff: '従業員を更新しています。 以前に支払ったことがあるが、更新されていない場合。 支払いの復元を選択してください。',
    staff1m: '1ヶ月延長',
    staff6m: '6ヶ月延長',
    staff1y: '1 年間延長'
  },
  category: {
    ...EN.category,
    id: 'カテゴリコード',
    prefix: 'カテゴリコードプレフィックス',
    title: 'カテゴリ',
    create: 'カテゴリを追加',
    name: 'カテゴリ名',
    choice: 'カテゴリの選択',
    search: 'コード、カテゴリ名でフィルタリング',
    categoryExist: 'カテゴリ名はすでに存在します',
    choiceProduct: 'カタログに追加する製品を選択してください',
    description: 'すべてのカテゴリを管理および追跡します。',
    tips: 'ヒント',
    tip1: '短くて理解しやすいカテゴリー名を使用してください（例：ドリンク、ファストフードなど）。',
    tip2: 'カテゴリーは、製品の分類と検索をより迅速にするのに役立ちます。',
    tip3: '作成後すぐに、このカテゴリーに製品を割り当てることができます。',
    itemsCountDesc: '現在このカテゴリーに含まれている %s 個のアイテム'
  },
  importOrder: {
    id: '単一コード',
    prefix: 'シングルエントリコードプレフィックス',
    title: '発注書',
    detail: 'アイテムの詳細',
    create: 'エントリを追加',
    edit: 'エントリーフォームの編集',
    editProductPrice: '入力価格を変更',
    editProductPriceWarning: 'この製品の輸入価格を %s に変更しますか?'
  },
  provider: {
    ...EN.provider,
    id: 'ベンダーID',
    prefix: 'ベンダープレフィックス',
    title: 'プロバイダー',
    create: 'プロバイダーの追加',
    name: 'ベンダー名',
    choice: 'ベンダーの選択',
    search: 'コード、名前、サプライヤー番号でフィルター',
    categoryExist: 'プロバイダー名は既に存在します',
    order: '注文',
    free: '不明',
    deleteWarning: 'この仕入先を削除してもよろしいですか？この仕入先に関連するすべての発注は「不明な仕入先」に変更されます。'
  },
  googleDriver: {
    loginGoogle: 'この機能を実行するには、Googleアカウントにサインインする必要があります',
    backup: 'バックアップ',
    backupToDriver: 'バックアップ',
    backupSuccess: 'バックアップが成功しました',
    backupError: 'バックアップに失敗しました',
    emptyBackup: 'バックアップが見つかりません',
    loadingBackupFile: 'バックアップデータの読み込み',
    backingUp: 'バックアップ',
    restore: '復元',
    restoreFromDriver: '復元',
    restoreSuccess: 'データ回復に成功しました',
    restoring: 'データの回復',
    resetData: 'データをリセット',
    resetDataDetail: 'データを最初からリセットする',
    resetDataConfirm: '現在のデータをワイプしてもよろしいですか？',
    backupErrorCaseInvalidToken: 'Googleアカウントセッションの有効期限が切れているため、データをバックアップできません。ログインしてもう一度お試しください！',
    confirmReplaceOlderTitle: '上書きの確認',
    confirmReplaceOlderDetail: 'Googleドライバーで新しいデータバージョンが見つかりました。現在のデータをバックアップしてもよろしいですか？',
    restoreChoose: '復元するデータを選択します',
    backupRename: '覚えやすい名前を編集する',
    backupAt: 'バックアップ場所'
  },
  rating: {
    title: 'アプリをお楽しみください',
    detail: 'このアプリに満足している場合は、レビューを書いて、最善を尽くしてください。',
    rateNow: '今すぐ評価',
    rateLater: '後で'
  },
  proVersion: {
    ...EN.proVersion,
    linked: 'リンク済み',
    paymentRecoveryHint: 'このアカウントを回復するお支払いを選択してください!',
    name: 'プレミアムエディション',
    detail: 'アプリのプレミアムバージョンを購入すると変更されます',
    removeAds: 'プレミアムバージョンを購入',
    removeAdsDetail: '1回だけ支払う必要があり、次回は自分自身を復元します',
    paymentRecovery: '支払い回収',
    paymentRecoveryDetail: 'プレミアムバージョンのアップグレードのために支払いを復元します',
    purchaseFailed: '支払いに失敗しました。もう一度やり直してください。',
    purchaseSuccess: '支払いは成功しました、ありがとうございます！',
    recoveryPaymentSuccess: '支払いの回収に成功しました！',
    recoveryPaymentUnsuccess: '支払いの回収に失敗しました。もう一度やり直してください！',
    recoveryIfNeed: 'すでに支払いを済ませている場合は、支払いを元に戻すことを選択してください。',
    cancelIfNeed: 'いつでもキャンセル',
    expireDate: '有効期限',
    expired: '古い',
    yourPackage: 'プレミアムバージョンを使用しています',
    packageFull: '無制限のライフタイムパッケージ',
    package1M: '1か月パッケージ',
    package3M: '3か月パッケージ',
    package6M: '6か月パッケージ',
    package1Y: '1年パッケージ',
    package5Y: '5年パッケージ',
    package10Y: '10 年パッケージ',
    package1MDetail: 'プレミアム バージョンを 1 か月間使用します。\n期限が切れると自動的に更新されます',
    package3MDetail: 'プレミアム バージョンを 3 か月間使用します。\n期限が切れると自動的に更新されます',
    package6MDetail: 'プレミアム バージョンを 6 か月間使用します。\nパッケージは時間の経過とともに累積され、自動的には更新されません。',
    package1YDetail: 'プレミアム バージョンを 1 年間使用します。\nパッケージは時間の経過とともに累積され、自動的には更新されません。',
    package5YDetail: 'プレミアム バージョンを 5 年間使用します。\nパッケージは時間の経過とともに累積され、自動的には更新されません。',
    package10YDetail: 'プレミアム バージョンを 10 年間使用します。\n自動更新はありません',
    packageWarehouse1Y: '1 年間の延長倉庫',
    packageWarehouse1YDetail: '1 年間別の拡張機能ストアを追加します。\n自動的に更新しません',
    packageStaff1Y: '従業員 1 年',
    packageStaff1YDetail: '従業員アカウントを 1 年間更新します。\n自分自身では更新しないでください',
    serviceFee: 'サービス料',
    packageAutoRenew: 'パッケージの自動更新',
    packageNonAutoRenew: 'パッケージは自動更新されません',
    notFoundPurchase: 'お支払いが見つかりませんでした',
    purchaseLinkedWithOtherAcc: 'この支払いはすでに別のアカウントにリンクされています',
    recoverySumary: '以前に支払った場合。 広告がまだ表示されているか、有料版の機能を使用していません。以下で支払いを復元することを選択してください',
    recoverySumary1: 'お支払いが正常に復元されたが、制限や広告が表示される場合は、アプリを終了して再度入力してください。',
    purchaseProcessing: '支払いはまだ処理中です。しばらくお待ちください。」 支払いが成功しても更新されない場合は、[支払いを復元] をクリックしてください。',
    iapInLoading: 'まだ準備ができていません。 しばらくお待ちください',
    yourPackageInfo: 'あなたのパッケージ',
    compare: 'バージョンを比較'
  },
  upgrade: {
    hasNewVersion: '新しいアップデートが利用可能です',
    changelog: '新しいバージョンでの変更',
    upgradeNow: '更新',
    later: '後で使用する',
    changeLogs: [
      '暗いテーマを選択するときにぼやけたテキストを修正する',
      '一部のデバイスで注文を保存できない問題を修正してください',
      '明るいインターフェースと暗いインターフェースに一致するように広告を最適化する',
      '開発者にバグレポートを送信する機能を追加する',
      'そして他のいくつかのマイナーなバグ修正'
    ]
  },
  profile: {
    ...EN.profile,
    title: '個人',
    nameShop: 'ショップ名',
    email: 'Eメール',
    address: 'アドレス',
    phone: '電話番号',
    numberPhone: 'Sdt',
    edit: '編集',
    save: '保存',
    bank: '銀行口座番号',
    placholderBank: '銀行口座を入力してください',
    placholderName: 'ショップ名を入力してください',
    placholderEmail: 'Eメールを入力してください',
    placholderAdress: '住所を入力してください',
    placholderPhone: '電話番号を入力してください',
    avatarEmpty: '写真を選択してください',
    nameEmpty: 'ショップ名を空にすることはできません',
    emailEmpty: 'メールを空にすることはできません',
    adressEmpty: 'アドレスを空にすることはできません',
    phoneEmpty: '電話番号を空白にすることはできません',
    billInfo: '店舗情報',
    placholderBillInfo: 'この情報は請求書に表示されます (電話番号、住所、銀行など)',
    freeAcc: '無料',
    proAcc: 'プレミアム'
  },
  invoice: {
    ...EN.invoice,
    stt: 'STT',
    titleImport: '輸入請求書',
    titleReturn: '返品請求書',
    title: '10億の支払い ',
    unit: 'ユニット',
    code: 'コード:',
    nameClient: 'クライアント',
    order: '商品コード',
    nameProduct: '商品名',
    number: 'SL',
    totalPrice: 'Into Money',
    price: '合計金額',
    money: '単価',
    buyer: '買い物客',
    salesman: '売り手',
    writeFull: '（署名、フルネーム）',
    day: '日付',
    month: '月',
    year: '年',
    save: '保存',
    thanks: '％s製品をご利用いただきありがとうございます。皆様のご多幸をお祈り申し上げます。'
  },
  barcode: { title: 'コードをスキャン', message: 'スキャンするコンテナにカメラを移動' },
  help: {
    removeAds: '広告を削除できますか？',
    removeAdsDetail: 'プレミアムバージョンパッケージを購入すると、広告を削除できます。パッケージを購入しなくても、アプリケーションのほとんどの機能を完全に使用できます。 ',
    adsNotDisable: 'プレミアムバージョンを購入しましたが、広告が表示されます',
    adsNotDisableDetail:
      '-「左上隅のメニューアイコン」->「プレミアムバージョン」->「支払いの復元」を選択します。青いメッセージが表示されたら、お支払いは正常に復元されています。広告は表示されなくなります。  n-赤いメッセージが表示された場合、支払いの回収は成功していません。お支払いを再確認してください。または、iTunesStoreアカウントに同じ支払いアカウントがあります。  n-支払いは成功したが、支払いの回収を有効にできない場合。メールで開発者に連絡してください:サポートについてはxgitdev@gmail.com ',
    recoveryData: 'データを別のマシンにバックアップまたは転送できますか？',
    recoveryDataeDetail:
      'アカウントを登録し、メニューを開いて現在のデータの同期を選択すると、データが失われることはなくなります。 デバイスにデータがない場合は、同期手順をスキップできます。\n別のデバイスでは、現在のアカウントにログインするだけで、デバイスを正常に使用できます。',
    recoveryDataAuto: 'データを自動的にバックアップすることは可能ですか？',
    recoveryDataeAutoDetail: 'この関数は設定で使用できます。ただし、この機能はプレミアムバージョンでのみ利用可能です。'
  },
  importFromCSV: {
    textHint: 'CSVファイルからテキストデータをここにインポートします',
    title: 'csvファイルからのクイックインポート',
    choiceFile: 'ファイルを選択',
    intro: '一括注文を作成するには、以下の内容を入力してください。サンプルとチュートリアルは、 ',
    enterText: 'テキストを入力してください',
    newCustomer: '新規顧客',
    productInvalid: '無効な商品',
    productInvalidMessage: '無効な商品コード。赤で強調表示されているアイテムのコードを再確認してください。',
    check: 'チェック',
    save: '注文を保存',
    emptyDataMessage: '注文が見つかりません',
    complete: '入力完了',
    gotIt: '私はそれを手に入れました',
    here: 'ここ',
    syntaxIntro1: 'サンプルのCSVファイルはここにあります。',
    syntaxIntro2: '次に、CSVファイルをテキストとして開き、CSVファイルの内容をコピーして、入力ボックスの入力ボックスに貼り付ける必要があります。',
    syntax: '構文',
    examp: '例',
    syntaxTut: '以下の構文に従ってデータをフォーマットしてください。注文はキャリッジリターンで区切られます。 ',
    syntaxDetail:
      '電話番号|顧客名|住所、追加料金、商品コード|数量|割引 n電話番号|顧客名|住所、追加料金、商品コード|数量|割引、コード商品|数量|割引 n電話番号|顧客名|住所、追加料金、商品コード|数量|割引、商品コード|数量|割引、商品コード|数量|割引、商品コード|数量|割引 ',
    syntaxExamp:
      '0123456789 | NGUYEN VAN A | Ha Noi、10、SP1 | 5 | 0  n0123456789 | NGUYEN VAN A | Ha Noi、10、SP1 | 5 | 0、SP2 | 4 | 0  n0123456789 | NGUYEN VAN A | Ha Noi、 10、SP1 | 5 | 0、SP2 | 4 | 0、SP3 | 4 | 0 '
  },
  bill: {
    ...EN.bill,
    name: '請求書',
    title: '支払い請求書',
    product: 'アイテム',
    day: '販売日',
    amount: '額',
    money: '合計金額',
    totalMoney: '合計金額',
    thanks: 'ありがとう！',
    createBy: 'アプリでプロフェッショナルに販売する',
    unit: '単位',
    discount2: '割引%',
    discount1: 'お金の割引',
    customImage: 'カスタム画像',
    customText: 'カスタムテキスト',
    moneyText: '金額の文字表記'
  },
  printer: {
    ...EN.printer,
    connected: 'プリンターは正常に接続されました。',
    name: 'プリンター',
    title: 'プリンタ接続',
    find: 'Bluetoothプリンターを探しています。しばらくお待ちください！',
    empty: 'プリンターが見つかりません',
    unknow: '不明',
    pressToConnect: 'タップしてプリンタデバイスを正しく接続します',
    notConnect: '設定でプリンタを接続してください。',
    trial: 'トライアルの％sが残っています',
    trialExpired: 'すべての試行を使い果たしました。この機能を使用するには、プレミアムバージョンにアップグレードしてください ',
    printError: 'プリンターの準備ができていません。もう一度やり直してください！',
    devicesTested: '開発チームによってテストされたデバイス: xPrinter 58iiH、GOOJPRT PT-210'
  },
  importFromExcel: {
    ...EN.importFromExcel,
    textHint: 'Excelファイルのテキストデータをここに入力してください',
    title: 'Excelファイルからのクイックインポート',
    choiceFile: 'ファイルを選択',
    intro: '一括注文を作成するには、以下の内容を入力してください。サンプルとチュートリアルは、 ',
    introProduct:
      '商品を素早くインポートするには、Excel ファイルを選択してください。 エクスポートしたファイルはファイル形式が異なりますので商品一覧から選択しないでください。 サンプルとチュートリアルは、',
    enterText: 'テキストを入力してください',
    introProduct1: '操作を簡単にするために Web バージョンを使用することをお勧めします。 システムが認識できるように、事前に単位とカテゴリを入力する必要があります',
    newCustomer: '新規顧客',
    productInvalid: '無効な商品',
    productInvalidMessage: '無効な商品コード。赤で強調表示されているアイテムのコードを再確認してください。',
    check: 'チェック',
    save: '%sつの製品を保存',
    emptyDataMessage: '注文が見つかりません',
    complete: '入力完了',
    gotIt: '私はそれを手に入れました',
    here: 'ここ',
    syntaxIntro1:
      '一度にインポートするレコードは500件未満にしてください。複数のファイルに分割してインポートすることもできます。商品名、コード、SKUが重複することはできません。変更が不要な列は削除してください。サンプルファイルはこちらで参照できます。',
    syntaxIntro2: '次に、Excelファイルをテキストとして開き、Excelファイルの内容をコピーして、入力ボックスの入力ボックスに貼り付ける必要があります。',
    found: '%s製品が見つかりました',
    demo: 'サンプルファイル'
  },
  unit: {
    ...EN.unit,
    id: 'ユニットコード',
    title: 'ユニット',
    choice: 'ユニットの選択',
    create: '新しいユニットを作成',
    name: 'ユニット名',
    search: 'コード、ユニット名でフィルタリング',
    exist: 'ユニット名はすでに存在します',
    tips: 'ヒント',
    tip1: '標準的な測定単位を使用してください（例：個、パック、ボックス、ケース...）。',
    tip2: '単位は、より正確な在庫管理と販売に役立ちます。',
    tip3: '製品の詳細で直接、単位変換を設定できます。'
  },
  timeFilter: {
    today: '今日',
    yesterday: '昨日',
    last7Days: '過去7日間',
    last30Days: '過去30日間',
    custom: 'カスタム',
    thisMonth: '今月',
    lastMonth: '先月',
    choiceStartDate: '開始',
    choiceMonth: '月を選択',
    choiceEndDate: '終了'
  },
  autoRestoreDb: {
    title: 'データ回復',
    message: 'アカウントのデータの新しいバージョンが検出されました。その最新のデータと同期しますか？'
  },
  support: {
    title: 'ライブサポート',
    emailSupportDetail: 'あなたは私たちに連絡したいです。 以下のいずれかの連絡方法を選択してください。',
    emailSupport: 'メール開発者',
    zaloSupportDetail: 'アプリケーションエラーなどの緊急サポート、またはその使用方法に関するFAQが必要な場合。 Zaloによるサポートを選択してください',
    zaloSupport: 'zaloグループによるサポート'
  },
  customerDebt: {
    ...EN.customerDebt,
    title: '負債合計',
    total: '未処理の合計',
    customerDebtStatistial: '顧客別債務',
    beginningBalance: '開始残高',
    beginDebts: '開始借方',
    closingBalance: '最終残高',
    closingDebts: '最終負債',
    simple: 'ショートバージョン'
  },
  returnOrder: {
    edit: '返品注文の編集',
    create: '返品注文を追加'
  },
  maintenance: {
    ...EN.maintenance,
    title: 'メンテナンス',
    message: 'サーバーは %s 分間メンテナンス中です。 また後で来てください。',
    timeout: '申し訳ありません。エラーが発生しました。数分後にもう一度お試しください。それでも解決しない場合は、サポートチームまでお問い合わせください。',
    messageTimeout:
      'サーバーが少し混雑しています! もう一度ダウンロードしてみてください。 それでも読み込まれない場合は、5 分ほど休憩してからもう一度お試しください。 どうもありがとうございます！',
    networkError: 'ネットワークエラー',
    networkErrorDetail: 'データのロードに失敗しました。 もう一度試してください。 エラーが何度も繰り返される場合。 5 分待ってからもう一度お試しください。'
  },
  financialBook: {
    ...EN.financialBook,
    debt: '借金メモ',
    createDebt: '借金を作成する',
    title: '財務省',
    receipts: '領収書',
    paymentVoucher: '支払伝票',
    moneyFromCustomer: '顧客コレクション',
    moneyForProvider: 'プロバイダーへの支払い',
    moneyForReturn: '払い戻しの払い戻し',
    moneyFromReturn: '仕入返品からの受入金',
    idAutoGen: '自動クーポンコード',
    cash: '現金',
    bank: '銀行',
    totalFund: '総資金',
    submitter: '作成者',
    typeCharge1: 'レシーバーの種類',
    typeCharge2: '属のタイプ',
    receipt: '領収書の作成',
    vouchers: 'バウチャーの作成',
    fullName: '氏名',
    submitters: '提出者',
    money: '金額',
    textEmptyFinancial: 'まだ領収書/支払いがありません。',
    accountBank: '受取口座',
    nameBank: '銀行口座',
    accountNumber: '口座番号',
    accountHolder: '口座名義人',
    receiptForOrder: '注文の受領書',
    paymentForOrder: '注文票',
    receiptFromCustomer: '顧客からの領収書',
    recipeAutoGenFor: '注文に対して自動的に生成された領収書',
    paymentForProvider: 'プロバイダーへの支払い',
    receiptAutoGenFor: '注文に対して自動的に生成された領収書',
    paymentForCustomer: '顧客の支払伝票',
    paymentVoucherAutoGenFor: 'オーダー自動生成小切手',
    autoFinancialCanNotEdit: 'このチケットは自動的に生成されます。 関連する注文を修正してください',
    createType: '新規作成',
    deleteType: 'カテゴリーの削除',
    deleteTypeWarning: 'カテゴリ %s を削除してもよろしいですか?',
    exportBill: '投票をエクスポート',
    deleteBill: '投票を削除',
    deleteBillWarning: 'このチケットを削除してもよろしいですか?',
    investment: 'インプットファンド',
    investmentDetail: '投入資金とは、初回販売時から期初までに計算される総残高（収益－支出）です。 \n例: 今月を選択した場合、投資資金はその月の 1 日以前の残高となります。',
    totalRevenue: '総収入',
    totalSpending: '総支出',
    totalBlance: '総残高'
  },
  sortType: {
    ...EN.sortType,
    newest: '最新',
    oldest: '最も古い',
    alphabet: 'アルファベット順'
  },
  guide: {
    revenue: '総収益',
    expenditure: '総支出',
    title: '初心者向けのヒント',
    expenseReport: '経費レポートを表示',
    product: '開始するには、提供する製品またはサービスを追加してください。',
    customer: '新しい顧客を追加することは、顧客情報を初期化し、将来の取引プロセスで負債を管理するための基本的な操作です.',
    provider: 'サプライヤーに関連するすべてのデータを管理できるように、サプライヤーを作成する必要があります: 連絡先情報、債務、輸入履歴...',
    order: '注文は在庫切れとして記録され、注文が作成されるとすぐに顧客に配送されます...注文のフィルタリングを容易にするために、注文メモとタグを注文に追加します..',
    category: 'Category は、アイテム カテゴリのコレクションを管理する場所です。',
    complete: '基本をマスターしました。 aSeler があなたのために設計した機能は他にもたくさんあります。'
  },
  productHistoryLog: {
    title: 'リポジトリ履歴',
    sale: 'エクスポート中',
    import: 'リポジトリのインポート',
    update: 'チェックアウト',
    return: '在庫の返金',
    delete: 'キャンセルの払い戻し',
    amount: '取引額',
    result: '取引後の金額',
    importReturn: '返品'
  },
  orderType: {
    ...EN.orderType,
    sale: '売上',
    return: '戻る',
    import: 'インポート',
    receipt: '領収書',
    payment: '支払い',
    debt: '借金',
    importReturn: '仕入返品'
  },
  newCodepush: {
    title: '新しいバージョンが利用可能です',
    des: '新しいバージョンがリリースされました。 今すぐ更新しますか?',
    cancel: '後で',
    ok: 'アップデート'
  },
  printSetting: {
    ...EN.printSetting,
    title: '請求書の印刷設定',
    type: 'プリンターの種類',
    connection: 'プリンター',
    asellerLogo: '販売者のロゴを表示',
    bluetooth: 'Bluetooth プリンター',
    wifi: 'WIFI プリンター',
    size: '印刷サイズ',
    deviceIp: 'プリンターのIPアドレス',
    deviceIpEx: '例: 192.168.1.100',
    invalidIP: '有効な IP を入力してください!',
    canNotConnectIP: 'この IP に接続できません。 プリンターの IP を再確認してください!',
    notReady: 'プリンターの準備ができていません。 まずプリンターの設定に行ってください',
    support:
      'WIFI, Bluetooth, USB에 연결된 ESC/POS 열전사 프린터를 지원합니다.\n참고: 라벨 프린터는 지원되지 않습니다. \n한 번에 1개의 장치만 프린터에 연결할 수 있습니다.\n테스트된 프린터: xPrinter 58iiH(블루투스), GOOJPRT PT-210(블루투스), xPrinter T80L(WIFI)',
    qrBank: '請求書の最後にカスタム写真を追加',
    qrBankDetail: '請求書の下部に表示される銀行の QR コードを追加できます'
  },
  homeOfflineWarning: {
    message: 'オフラインで使用しています。」 より多くの機能を使用するには、オンラインに切り替えてください。 データは失われません。',
    helpButton: 'オンラインに切り替える方法'
  },
  statStock: {
    typeChoice: '在庫統計の基準',
    inventoryCapital: '在庫'
  },
  customerGroup: {
    title: '顧客グループ',
    search: '名前またはコードでフィルタリング',
    id: 'グループコード',
    prefix: 'グループ コード プレフィックス',
    create: 'グループを追加',
    choice: 'ゲストグループを選択',
    choiceCustomers: '顧客をグループに追加',
    name: 'グループ名',
    tablePrice: '価格表',
    priceHint: '顧客がこのグループに属している場合、価格表は販売注文に自動的に適用されます',
    editNotice: '編集モード - 右上の「保存」をタップして完了',
    removeCustomer: 'この顧客をグループから削除してもよろしいですか?'
  },
  settings: {
    title: '設定',
    garena: '一般設定',
    home: 'ホーム設定',
    product: '製品設定',
    order: '注文設定',
    invoice: '請求書設定',
    debt: 'バランス設定',
    point: 'ポイント設定',
    salesGroup: '販売と請求書',
    systemGroup: 'システムと画面',
    businessGroup: '顧客とビジネス',
    accountGroup: 'アカウントとセキュリティ',
    displayAndTheme: '表示とテーマ',
    currencyAndTime: '通貨と時間',
    security: 'セキュリティ',
    stockSettings: '在庫設定',
    homeWidgets: 'ホームウィジェット',
    pointSettings: 'ポイント設定',
    resetPointTitle: '設定リセット',
    systemPermissions: 'システム権限',
    invoiceSettings: '請求書設定',
    debtSettings: '売掛金設定',
    orderSettings: '注文設定',
    descOrder: 'ステータス、端数処理、追加料金、時間制サービス',
    descProduct: '在庫、原価、初期在庫',
    descInvoice: '請求書テンプレート、VietQR、銀行口座',
    descPrinter: '用紙サイズ、Bluetooth、Wifi、USBプリンター',
    descShift: 'シフト開始、終了、現金引き継ぎ',
    descGeneral: 'テーマ、言語、フォントサイズ、通貨、PIN',
    descHome: '売上表示、グラフ、財務レポート',
    descPermission: 'カメラ、写真ライブラリ、Bluetooth、通知',
    descPoint: '会員ポイント、交換レート',
    descShop: '支店管理、スタッフ管理、販売ウェブサイト',
    descEInvoice: '電子請求書の設定と発行',
    descPassword: 'アカウントパスワードの変更',
    descDeleteAcc: 'アカウントと店舗データを完全に削除',
    shopManager: '店舗マネージャー',
    staffRole: 'スタッフ',
    granted: '許可済み',
    grantPermission: '許可する',
    noVietQRConfig: 'VietQR銀行口座が未設定です',
    uploadQRImage: 'QRコード画像をアップロード',
    s2aHkdGroup: 'S2A-HKD 業種グループ',
    s2aHkdGroupDetail: 'S2A-HKD帳簿出力時のデフォルト業種',
    s2aHkdTaxRate: 'S2A-HKD デフォルトVAT税率 (%)',
    s2aHkdTaxRateDetail: '商品/注文に明確なVATがない場合に使用',
    s2aHkdTncnRate: 'S2A-HKD 個人所得税率 (%)',
    s2aHkdTncnRateDetail: 'S2A-HKD出力時の個人所得税率(%)',
    manualEnterIPDetail: 'プリンターが検出されない場合は直接IPを入力してください',
    previewPrint: '印刷プレビュー'
  },
  customerPoint: {
    ...EN.customerPoint,
    point: '累計ポイント',
    description: '顧客報酬管理',
    history: '累積履歴',
    use: 'ポイント蓄積機能を有効にする',
    mtpRate: 'ポイント換算率',
    mtpRateDetail: '注文額 %s%s = 累積ポイント 1',
    ptmRate: 'お金への換算率',
    ptmRateDetail: '1 ポイント = %s%s',
    allowPayment: 'ポイントによる支払いを許可',
    allowForSaleProduct: '割引商品でポイントを獲得',
    allowForOrderPayByPoint: '特典ポイントで支払い注文を蓄積',
    change: '累計ポイントを更新',
    invalidPoint: '無効なポイント',
    invalidNote: 'メモを入力してください',
    usePoint: '使用中のポイント',
    showPointOnInvoice: '請求書にポイントを表示',
    reset: '蓄積されたポイントをすべて削除',
    resetWarning: '顧客の現在蓄積されたポイントをすべて削除してもよろしいですか?'
  },
  shift: {
    ...EN.shift,
    title: 'シフトを閉じる',
    end: 'シフトを閉じる',
    totalOrder: '請求書の合計額',
    totalMoney: '合計シフト',
    paid: '完全なハンドオーバー',
    staff: '従業員',
    cash: '現金',
    bank: '転送',
    shiftOrder: 'シフト注文',
    open: 'シフトを開始',
    closed: 'シフトを閉じる',
    opening: 'シフトを開始',
    openingAmount: '開始時の現金',
    handoverType: '引継ぎ方法',
    actualHandoverAmount: '実際の引継ぎ額',
    differenceAmount: '差額',
    totalExpectedHandoverAmount: '引き渡す必要のある総額',
    orderUnit: '注文',
    currencyUnit: '₫',
    endReport: 'シフト終了レポート',
    ended: 'シフト終了',
    shift: '販売シフト',
    actualHandoverDesc: 'スタッフが実際に引き渡した金額',
    updatingOnClose: 'シフト終了時に更新されます',
    matchedDiffDesc: '金額が完全に一致しています',
    checkDiffDesc: '差異の理由を確認・照合してください',
    diffCalculatedOnClose: 'シフト引き継ぎ後に計算されます',
    searchOrdersPlaceholder: '注文番号、顧客、電話番号で検索...',
    emptyOrder: 'このシフトではまだ注文が発生していません。',
    handoverTypeDetail: 'スタッフがシフトを締めて引き継ぐ際に受け取った支払い方法',
    requireOpening: 'シフト開始を必須にする',
    requireOpeningDetail: 'シフト開始中のみ販売注文を作成できます',
    settings: 'シフト設定',
    settingsDetail: 'シフト開始と引継ぎを設定',
    openError: 'シフトを開始できません',
    expectedHandoverAmount: '引継ぎ予定額',
    totalMoneyInShift: 'シフト内の合計金額',
    needHandover: '引き渡し予定',
    endConfirm: 'このシフトを終了してもよろしいですか？'
  },
  warehouse: {
    ...EN.warehouse,
    title: '倉庫',
    renew: '倉庫の更新',
    choice: '倉庫の選択',
    stat: '在庫状況',
    createNew: 'チケットの作成',
    create: '在庫を作成する',
    checkId: '在庫コード',
    name: '倉庫名',
    check: '在庫を確認',
    createCheck: '在庫チェックを作成',
    history: 'インベントリ履歴',
    noHistory: '在庫履歴はまだありません。 新しいチケットを作成してください',
    noTransferHistory: 'まだ転送履歴がありません!',
    totalProduct: '製品合計',
    tmpCheck: '仮チケット',
    cancelCheckConfirm: 'このチェックをキャンセルしてもよろしいですか?',
    cancelTransferConfirm: 'この転送をキャンセルしてもよろしいですか?',
    default: 'メインリポジトリ',
    address: 'リポジトリアドレス',
    manager: '在庫管理',
    detail: 'インベントリ情報',
    transfer: '在庫を転送',
    transferCard: '倉庫振込伝票',
    checkCard: '在庫確認伝票',
    emptyTargetWarehouse: '宛先ウェアハウスが無効です。 目的地の倉庫を選択してください!',
    limit: '注: 各アカウントは 2 番目のウェアハウスを 1 か月間無料で利用できます。有効期限が切れた後は、使用するには更新する必要があります',
    expired: 'このリポジトリの有効期限が切れています。 更新してご利用ください!',
    package1Y: '1 年間の延長',
    emptyTransferHint: '「バーコード」または「商品」をタップして移動を開始',
    emptyCheckHint: '「バーコード」または「商品」をタップして棚卸しを開始',
    noProduct: '商品が選択されていません'
  },
  homeScreen: {
    ...EN.homeScreen,
    support: 'サポートが必要ですか?',
    supportDetail: '質問に答えるか、問題を報告してください',
    changelog: '変更ログ',
    changelogDetail: '変更ログ、アプリケーションの最新機能を追跡します。 ',
    autoUpdate: '自動更新',
    autoUpdateDetail: '新しいアップデートが利用可能になると、システムはアップデート要求を表示します。 オフにすると、バグ修正や新機能を見逃す可能性があります。',
    autoUpdateNoAvailable: '最新バージョンを使用しています!',
    autoUpdateFailed: '更新プロセス中にエラーが発生しました。 後でもう一度試してください。',
    vipExpired: 'プレミアム パッケージの有効期限が切れています。 すべての機能を利用するには更新してください。'
  },
  productSetting: {
    ...EN.productSetting,
    sort: 'リストのソート',
    sortDetail: '商品の並べ替え基準',
    sortTypes: ['新しい順', 'アルファベット順', '古い順']
  },
  intro: {
    ...EN.intro,
    shift: 'この機能はサービス業向けです。 従業員は従業員アプリを使用してシフトを締めます。 従業員のシフト終了情報がここに表示されます。',
    customerGroup:
      'この機能は顧客オブジェクトをグループ化することです。 たとえば、レベル 1 エージェント、レベル 2 エージェント... 顧客グループごとに商品の価格表を作成できます。 注文を作成するときに、顧客が価格表のあるグループに属している場合、その価格表が自動的に適用されます!',
    emptyProduct: 'まだ商品はありません。 継続するにはさらに商品を追加してください!',
    draftOrder:
      '複数の注文を同時に作成したい場合に適した機能です。 また、ネットワークに接続していなくても販売注文を作成できます。 これは、接続に問題がある場合、またはサーバーがメンテナンス中の場合に非常に役立ちます。'
  },
  printBarcode: {
    ...EN.printBarcode,
    print: 'バーコードを印刷'
  },
  draftOrder: {
    ...EN.draftOrder,
    title: '請求書草案',
    manager: '請求書草案を管理',
    cancel: '下書きをキャンセル',
    cancelConfirm: 'この請求書草案をキャンセルしてもよろしいですか?',
    noConnectionWarning: 'デバイスはネットワークに接続されていません。 インターネット接続を必要とせずに請求書草案を作成するには、以下の「請求書草案の管理」に移動してください。'
  },
  appError: {
    eyebrow: '問題が発生しました',
    title: 'アプリを再起動してください',
    detail: '予期しないエラーが発生しました。続行するにはアプリを再起動してください。',
    reload: 'アプリを再起動'
  },
  introData: [
    {
      title: 'aSeller POS へようこそ！',
      detail: 'いつでもどこでもお店を管理できる、スマートな販売管理ソリューション。'
    },
    {
      title: '注文、商品、顧客を簡単に管理',
      detail: '売上、支出、債務、在庫の出入り、領収書の発行を数タップで管理。'
    },
    {
      title: 'データはクラウドに安全に保存され、複数のデバイスで同期可能。',
      detail: '📶 いつでもアクセスでき、デバイスを変更してもデータを失う心配なし！'
    },
    {
      title: '販売管理がこれまでになく簡単に！',
      detail: '店舗を作成し、商品を追加し、aSeller POS で今すぐ販売を開始しましょう。'
    }
  ],
  shipping: {
    ...EN.shipping,
    createHint: '手動で配送を作成するか、設定済みの配送業者 API を呼び出せます。',
    createMode: '作成モード',
    createModeHintManual: '内部配送を作成し、追跡コードを手入力できます。',
    createModeHintProvider: '配送業者 API を呼び出して配送を作成し、追跡コードを自動取得します。',
    providerModeUnavailable: 'この配送業者は API 作成用の設定が不足しているため、手動モードを使用します。',
    providerCodeAutoGenerated: '配送の作成に成功すると、追跡コードは配送業者から返されます。',
    providerCreateFailed: '配送業者での配送作成に失敗したため、内部配送は保存されませんでした。',
    irregularTransitionConfirm: '選択されたステータスは通常の処理フローにありません。更新してもよろしいですか？',
    invalidProviderConfigJson: 'Credentials または settings JSON が不正です',
    providerSettings: 'Provider Settings',
    providerSettingsJson: 'Provider Settings (JSON)',
    providerConfigGuide: 'Suggested fields by provider',
    createModeList: {
      manual: '手動作成',
      provider: '配送業者経由で作成'
    }
  }
};
